export const StickyFooter = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <>
      <div aria-hidden="true" className="c-sticky-footer__shadow"></div>
      <div aria-hidden="true" className="c-sticky-footer__cover"></div>
      <div
        className={`c-sticky-footer ${
          className ?? ""
        } d-flex align-items-center`}
      >
        <div className="c-sticky-footer-inner d-flex gap-2 flex-row justify-content-between align-items-center flex-100">
          {children}
        </div>
      </div>
    </>
  );
};
